import { render, staticRenderFns } from "./PointsConfig.vue?vue&type=template&id=74b0a145&scoped=true"
import script from "./PointsConfig.vue?vue&type=script&lang=js"
export * from "./PointsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b0a145",
  null
  
)

export default component.exports